module.exports = __webpack_public_path__ + "static/media/cdb10.b8fc0b92.png";